import { EStudyInformStatus } from "./enums";


export const STUDY_STATUS_LABEL = {
  SD_REQUESTED: "Pendiente",
  SD_INFORMED_PARTIAL: "Parcial",
  SD_INFORMED_COMPLETE: "Informado",
  SD_VALIDATED: "Validado",
  SD_CANCELED: "Cancelado",
};

export const STUDY_STATUS_LABEL_BY_NUMBER: Record<number, string> = {
  [EStudyInformStatus.SD_REQUESTED]: STUDY_STATUS_LABEL.SD_REQUESTED,
  [EStudyInformStatus.SD_INFORMED_PARTIAL]: STUDY_STATUS_LABEL.SD_INFORMED_PARTIAL,
  [EStudyInformStatus.SD_INFORMED_COMPLETE]: STUDY_STATUS_LABEL.SD_INFORMED_COMPLETE,
  [EStudyInformStatus.SD_VALIDATED]: STUDY_STATUS_LABEL.SD_VALIDATED,
  [EStudyInformStatus.SD_CANCELED]: STUDY_STATUS_LABEL.SD_CANCELED,
};

export const STATUS_PENDING_OPTIONS = [
    { label: 'Todos', value: 0 },
    { label: 'Pendiente', value: 1 },
    { label: 'Parcial', value: 2 },
];


export const STATUS_FINISHED_OPTIONS = [
    { label: 'Informado', value: EStudyInformStatus.SD_INFORMED_COMPLETE },
    { label: 'Parcial', value: EStudyInformStatus.SD_INFORMED_PARTIAL },
    { label: 'Validado', value: EStudyInformStatus.SD_VALIDATED },
]

